<template>
  <div class="notification-container hideContainer">
    <div v-on:click="clearNotification" class="drop-notification">
      <span v-if="statusCode === 1" class="status-icon"><img src="@/assets/images/icons/success.svg"></span>
      <span v-if="statusCode === 2" class="status-icon"><img src="@/assets/images/icons/success.svg"></span>
      <span v-if="statusCode === 3" class="status-icon"><img src="@/assets/images/icons/warning.svg"></span>
      <span v-html="message"></span>
    </div>
  </div>


</template>

<script>

import EventBus from '@/components/utilities/EventBus'

export default {
  name: 'DropNotification',
  data () {
    return {
      message: '',
      statusCode: null,
      statusMap: {
        1: 'green',
        2: 'yellow',
        3: 'red'
      },
      messageQueue: []
    }
  },
  mounted () {
    EventBus.$on('drop', (payload) => {
      this.messageQueue.push(payload)
      if (this.messageQueue.length > 1) return
      this.show()
    })
  },
  methods: {
    show () {
      let payload = this.messageQueue[0]
      if (!payload) return

      let duration = 3000

      if (payload.duration) duration = payload.duration
      this.message = payload.message
      this.statusCode = payload.statusCode

      $('.notification-container').removeClass('hideContainer')
      $('.drop-notification').addClass('slideEffect')

      // Adds slideUp animation
      setTimeout(() => {
        $('.drop-notification').removeClass('slideEffect')
        $('.notification-container').addClass('hideContainer')
        this.messageQueue.splice(0, 1)
        this.statusCode = null
        this.show()
      }, duration)
    },
    clearNotification () {
      $('.drop-notification').removeClass('slideEffect')
      $('.notification-container').addClass('hideContainer')
    }
  }
}
</script>

<style lang="scss">

.drop-notification {
  width:                      80%;
  text-align:                 center;
  padding:                    1em;
  position:                   fixed;
  z-index:                    999999;
  visibility:                 hidden;
  background-color:           #000000;
  color:                      #fff;
  border-radius:              0.1em;
  margin-top:                 1em;
  margin-left:                10%;
  top:                        0;
  cursor:                     pointer;

  &.closed {
    display:                  none;
  }

  .status-icon {
    display:                  block;

    > img {
      width:                  2em;
      height:                 2em;
      margin-bottom:          1em;
    }
  }

}

.slideEffect {
  animation-name: slideEffect;
  -webkit-animation-name: slideEffect;

  animation-duration: 2s;
  -webkit-animation-duration: 2s;

  animation-timing-function: ease;
  -webkit-animation-timing-function: ease;

  visibility: visible !important;
}

@keyframes slideEffect {
  0% {
    transform: translateY(-100%);
  }
}

@-webkit-keyframes slideEffect {
  0% {
    -webkit-transform: translateY(-100%);
  }
}

/* Portrait tablet to landscape and desktop */
@media (max-width: 768px) {

  .notification-container {

    position:                     fixed;
    background-color:             rgba(0, 0, 0, .5);
    top:                          0;
    bottom:                       0;
    left:                         0;
    right:                        0;
    z-index:                      999999;

    &.hideContainer {
      display:                    none;
    }

    .drop-notification {
      width:                      100%;
      bottom:                     0;
      top:                        unset;
      background:                 #fff;
      color:                      #000000;
      margin:                     0;
      left:                       0;
      padding:                    4em 0;

      &.closed {
        display:                  none;
      }

      .status-icon {
        display:                  block;

        > img {
          width:                  2em;
          height:                 2em;
          margin-bottom:          1em;
        }
      }
    }
  }

  .slideEffect {

    animation-duration: 1.3s;
    -webkit-animation-duration: 1.3s;

    animation-timing-function: ease;
    -webkit-animation-timing-function: ease;

    visibility: visible !important;
  }

  @keyframes slideEffect {
    0% {
      transform: translateY(100%);
    }
  }

  @-webkit-keyframes slideEffect {
    0% {
      -webkit-transform: translateY(100%);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/utilities/DropNotification.vue